import React from 'react';


const services = [
    {
        icon: 'icon-processor',
        slug: 'ai-and-quantum-technology',
        title: (
            <>
                FENNEQ - AI &{` `}<br />
                Optimization Platform
            </>
        ),
        card: "FENNEQ is our end-to-end platform that transforms complex business problems into optimized solutions. Bring your historical data and describe your challenge — no mathematical modeling, quantum expertise, or coding required. Our platform automatically deploys the optimal solver: quantum, hybrid, reinforcement learning, or classical optimizers.",
    },
    {
        icon: 'icon-shield-check',
        slug: 'post-quantum-encryption',
        title: (
            <>
                QASER - Sovereign{` `}
                Post-Quantum Cryptography
            </>
        ),
        card: "QASER (كاسر) is our homegrown, sovereign post-quantum cryptography suite. Our NIST-validated implementations of ML-KEM and ML-DSA provide quantum-safe encryption and digital signatures. Includes a complete migration framework — from cryptographic inventory to our proxy-based transition architecture.",
    },
].map(item => ({
    ...item,
    parent: 'services',
}));

export default services;
